<!--
 * @Author       : saisai
 * @Date         : 2023-01-05 15:14:48
 * @LastEditors: Liu SaiSai liusaisai@jtexpress.com
 * @Description  : 物流轨迹组件
-->
<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item
        :title="$lang('基础信息')"
        name="1"
      >
        <detail-min-table
          v-if="tabs.includes('base')"
          :value="isEmptyObj(orderInfo) ? [] : [orderInfo]"
          :option="baseInfoTable"
        >
          <template slot="operationSlot">
            <el-button
              type="text"
              @click="orderInfoOperation"
            >{{ $lang(orderInfoShow? '关闭' : '展开') }}</el-button>
          </template>
        </detail-min-table>
        <el-collapse-transition>
          <div v-show="orderInfoShow && !isEmptyObj(orderInfo)">
            <slot
              v-if="$slots.base"
              name="base"
            />
            <detail-base-info
              v-else
              :value="orderInfo"
              :show-warn="showWarn"
              @getAddressDetail="getAddressDetail"
            />
          </div>
        </el-collapse-transition>
      </el-collapse-item>
      <el-collapse-item
        :title="$lang('异常信息')"
        name="3"
        v-if="waringData.levelTwoTypeName || waringData.agreementCustomerFlag"
      >
        <div class="warning">
          <span class="el-icon-warning"></span>
          <div>
            <div
              v-if="waringData.isNetworkException"
              :class="colorStyle[waringData.colorLabel]"
            >
              异常网点：<span>{{waringData.networkName}}</span>
            </div>
            <div
              v-if="waringData.isTaskException"
              :class="colorStyle[waringData.colorLabel]"
            >
              任务编码：<span>{{waringData.taskNo}}</span>
            </div>
            <div :class="colorStyle[waringData.colorLabel]" v-if="waringData.levelTwoTypeName">
              异常类型：<span>{{waringData.levelTwoTypeName||'--'}}</span>
            </div>
            <div :class="colorStyle[waringData.colorLabel]" v-if="waringData.levelTwoTypeName">
              异常原因：{{waringData.abnormalCauses||'--'}}
            </div>
            <div v-if="waringData.levelTwoTypeName">
              应对话术：{{waringData.speechcraft||'--'}}
            </div>
            <div v-if="waringData.agreementCustomerFlag">
              客户信息：<b class="text-red">协议客户</b>
            </div>
            <div v-if="waringData.agreementCustomerFlag">
              备注：<b>破损问题类型优先转始发处理</b>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="showPickupInfo"
        :title="$lang('取件信息')"
        name="6"
      >
        <pickup-info
          :waybillNo="inputType === 'orderNo' ? orderNo : waybillNo"
          :inputType="inputType"
          :visible="pickupInfoVisible"
          :showCancelBtn="showCancelBtn"
          @looseOrderStatus="$emit('looseOrderStatus', $event)"
        />
      </el-collapse-item>
      <el-collapse-item
        :title="$lang('物流轨迹')"
        name="2"
      >
        <div class="trail-btn" v-if="showConsolidation">
          <span
            :class="tableType===1? 'trail-btn-active':''"
            @click="changeTrailType(1)"
            >{{$lang('内网轨迹')}}</span>
          <span
            :class="tableType===2? 'trail-btn-active':''"
            @click="changeTrailType(2)"
            >{{$lang('官网轨迹')}}</span>
          <div class="trail-tip">
            <i class="iconfont iconjinggao1"></i>
            <span>严禁将内网轨迹截图发送给任何人</span>
          </div>
          <span
            @click="batchQueryRegister(3)"
            v-show="showbackTransfer"
            style="margin-left:10px;border-radius: 10px"
          >{{$lang('退回')}}</span>
          <span
            @click="batchQueryRegister(5)"
            v-show="showbackTransfer"
            style="margin-left:10px;border-radius: 10px"
          >{{$lang('改地址')}}</span>
        </div>
        <!-- 内网 -->
        <TrajectoryRecord v-if="tableType===1" :trackList="trailList" :option="option" :trailErrorMsg="trailErrorMsg" @sendSignImg="$emit('sendSignImg', $event)">
          <template slot="scanTimeSlotTitle">
            <span
              class="pointer-view"
              @click="trailSwitch('trailList')"
            >
              {{ $lang('扫描时间') }}
              <span class="switch-icon">
                <i
                  class="my-icon my-icon-1 el-icon-caret-top"
                  :class="switchUp ? 'active' : ''"
                ></i>
                <i
                  class="my-icon my-icon-2 el-icon-caret-bottom"
                  :class="!switchUp ? 'active' : ''"
                ></i>
              </span>
            </span>
          </template>
        </TrajectoryRecord>
        <!-- 官网 -->
        <TrajectoryRecord v-else :trackList="ExternalNetworkList" :option="ExternalNetworkOption">
        </TrajectoryRecord>
      </el-collapse-item>
      <template v-if="tableType===1">
        <el-collapse-item
          v-for="(item,index) in consolidationCods"
          :key="index"
          :title="$lang(item.title)+'：'+item.list[0].waybillNo"
          :name="item.key"
        >
          <TrajectoryRecord :trackList="item.list" :option="option" :trailErrorMsg="trailErrorMsg">
            <template slot="scanTimeSlotTitle">
              <span
                class="pointer-view"
                @click="trailSwitch(item.prop)"
              >
                {{ $lang('扫描时间') }}
                <span class="switch-icon">
                  <i
                    class="my-icon my-icon-1 el-icon-caret-top"
                    :class="switchUp ? 'active' : ''"
                  ></i>
                  <i
                    class="my-icon my-icon-2 el-icon-caret-bottom"
                    :class="!switchUp ? 'active' : ''"
                  ></i>
                </span>
              </span>
            </template>
          </TrajectoryRecord>
        </el-collapse-item>
      </template>
    </el-collapse>
    <!-- 改地址 -->
    <el-dialog
      :title="$lang('修改收件地址')"
      :visible.sync="visible"
      width="702px"
      :close-on-click-modal="false"
      :append-to-body="true"
      @close="handleClose"
    >
    <avue-form  ref="formData"
      v-model="formData"
      :option="addressDetailOpt">
        <template slot="waybillNo">
          <span>运单编号：{{waybillNo}}</span>
        </template>
        <template slot="receiverProvinceId">
          <el-select v-model="selectProvide"  value-key="id" @change="changeProvide">
            <el-option v-for="item in provideList" :key="item.id" :label="item.nativeName" :value="item" ></el-option>
          </el-select>
        </template>
        <template slot="receiverCityId">
          <el-select v-model="selectCity"  value-key="id" @change="changeCity">
            <el-option v-for="item in cityList" :key="item.id" :label="item.nativeName" :value="item" ></el-option>
          </el-select>
        </template>
        <template slot="receiverAreaId">
          <el-select v-model="selectArea"  value-key="id" @change="changeArea">
            <el-option v-for="item in areaList" :key="item.id" :label="item.nativeName" :value="item" ></el-option>
          </el-select>
        </template>
        <template slot="opsIntercept">
        <el-input placeholder="请输入内容" v-model="opsIntercept" style="width:86%" >
        </el-input>
         <el-button slot="append" type="primary" @click="handleOpsIntercept">{{$lang('智能识别')}}</el-button>
        </template>
         <template slot="receiverMobilePhone">
          <span class="form-second">{{ $lang('手机号:') }}</span>
          <span class="form-tip">{{ $lang('（手机和座机必填其一）') }}</span>
          <el-input v-model="formData.receiverMobilePhone"></el-input>
        </template>
        <template slot="receiverTelphone">
          <span class="form-second">{{ $lang('电话:') }}</span>
          <span class="form-tip">{{ $lang('（手机和座机必填其一）') }}</span>
          <el-input v-model="formData.receiverTelphone"></el-input>
        </template>
      </avue-form>
     <span slot="footer" class="dialog-footer">
      <el-button type="primary"  @click="changeAddress">{{$lang('保存')}}</el-button>
    </span>
    </el-dialog>
     <!-- 改地址 -->
    <el-dialog
      :title="$lang('退回')"
      :visible.sync="backVisible"
      width="300px"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
    <avue-form  ref="backFormData"
      v-model="backFormData"
      :option="backOpts">
      <template slot="receiverMobilePhone">
          <div>
          <el-input v-model="backFormData.receiverMobilePhone" style="width: 200px;margin-right:5px;" :disabled="receiverMobilePhoneStatus"></el-input>
          <el-button type="primary" @click="editReceiverMobilePhoneStatus">{{$lang('编辑')}}</el-button>
          </div>
          <div style="font-size: 12px;color:red;margin-top:20px;">
            默认: 退件接收人联系手机=原寄件人手机，如有变动，支持修改
          </div>
        </template>
      </avue-form>
     <span slot="footer" class="dialog-footer">
      <el-button type="primary"  @click="backTransfer">{{$lang('保存')}}</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import { baseInfoTable } from './option'
import { isEmptyObj } from '@/common/utils/tool'
import { BackTransferApi } from '../pool'
import { RULES } from '@/common/utils/validators'
import { RESPONSE_CODE } from '@public/http/config';
import PickupInfo from './PickupInfo'
export default {
  components: {
    PickupInfo
  },
  props: {
    trailList: Array, // 物流轨迹内网数据
    ExternalNetworkList: Array, // 物流轨迹官网数据
    orderInfo: Object, // 基础信息数据
    waybillNo: String,
    showWarn: Boolean,
    trailErrorMsg: String,
    tabs: Array,
    option: Object,
    firstTrailList: Array,
    secondTrailList: Array,
    waringData: Object,
    showbackTransfer: Boolean, // 是否展示退回按钮
    showPickupInfo: Boolean, // 是否显示取件信息面板
    inputType: String, // 输入类型：'waybillNo' 或 'orderNo'
    orderNo: String, // 订单号
    showCancelBtn: Boolean // 是否显示取消订单按钮
  },
  data() {
    return {
      activeNames: ['1', '2', '3', '4', '5'],
      baseInfoTable, // 基础信息列表
      orderInfoShow: false, // 是否展示基础信息 下拉
      switchUp: false, // 物流轨迹升降序
      isEmptyObj,
      colorStyle: {
        1: 'color-red',
        2: 'color-blue',
        3: 'color-green'
      },
      routeName: '',
      tableType: 1,
      ExternalNetworkOption: {
        showNetInfo: false,
        abnormalTask: false,
        showStopList: false,
        showPackInfo: false,
        width: '660px',
        head: [
          {
            label: '扫描时间', style: { width: '78px' },
            prop: 'scanTime',
            html: true,
            formatter: ({ scanTime }) => scanTime.replace(/\s/, '<br>')
          },
          { label: '扫描类型', style: { width: '60px' }, prop: 'scanTypeName' },
          { label: '跟踪记录描述', style: { flex: '1 1' }, prop: 'customerTracking' }
        ]
      },
      visible: false,
      backVisible: false,
      provideList: [],
      cityList: [],
      areaList: [],
      selectProvide: '',
      selectCity: '',
      selectArea: '',
      formData: {},
      opsIntercept: '',
      opsInterceptObj: {},
      backFormData: {
        receiverMobilePhone: ''
      },
      receiverMobilePhoneStatus: true
    }
  },
  computed: {
    showConsolidation() {
      return ['callCenter', 'imService'].includes(this.$route.name)
    },
    // 取件信息面板是否展开
    pickupInfoVisible() {
      return this.showPickupInfo && this.activeNames.includes('6')
    },
    consolidationCods() {
      return [
        {
          title: '集运二段',
          key: '5',
          list: this.secondTrailList,
          prop: 'secondTrailList'
        },
        {
          title: '集运一段',
          key: '4',
          list: this.firstTrailList,
          prop: 'firstTrailList'
        }
      ].filter(o => o.list.length)
    },
    addressDetailOpt() {
      return {
        menuBtn: false,
        column: [
          {
            label: '',
            prop: 'waybillNo',
            formslot: true,
            span: 24
          },
          {
            label: '收件姓名',
            prop: 'receiverName',
            rules: [RULES.required, RULES.lengthTen]
          },
          {
            label: '',
            prop: 'receiverMobilePhone',
            formslot: true,
            rules: this.formData.receiverTelphone ? [RULES.checkPhoneAndTel] : [RULES.required, RULES.checkPhoneAndTel]
          },
          {
            label: '',
            prop: 'receiverTelphone',
            formslot: true,
            rules: this.formData.receiverMobilePhone ? [RULES.checkPhoneAndTel] : [RULES.required, RULES.checkPhoneAndTel]
          },
          {
            label: '收件省份',
            prop: 'receiverProvinceId',
            formslot: true,
            rules: [RULES.required]
          },
          {
            label: '收件城市',
            prop: 'receiverCityId',
            formslot: true,
            rules: [RULES.required]
          },
          {
            label: '收件区县',
            prop: 'receiverAreaId',
            formslot: true,
            rules: [RULES.required]
          },
          {
            label: '详细地址',
            prop: 'receiverDetailedAddress',
            span: 24,
            rules: [RULES.required],
            type: 'textarea',
            showWordLimit: true
          },
          {
            label: '智能识别',
            prop: 'opsIntercept',
            span: 24,
            formslot: true
          },
          {
            label: '转寄申请原因',
            prop: 'rebackTransferReason',
            span: 24,
            type: 'textarea',
            maxlength: 50,
            showWordLimit: true
          }
        ]
      }
    },
    backOpts() {
      return {
        menuBtn: false,
        column: [
          {
            label: '收件人手机号',
            prop: 'receiverMobilePhone',
            formslot: true,
            rules: this.receiverMobilePhoneStatus ? [] : [RULES.cell_phone],
            span: 24
          }

        ]
      }
    }
  },
  methods: {
    // 基础信息展开
    orderInfoOperation() {
      this.orderInfoShow = !this.orderInfoShow
    },
    // 物流轨迹排序
    trailSwitch(propList) {
      const list = propList || 'trailList'
      if (!this[list].length) return
      this.switchUp = !this.switchUp
      this[list].reverse()
    },
    getAddressDetail() {
      this.$emit('getAddressDetail', { waybillNo: this.waybillNo })
    },
    // 切换轨迹类型
    changeTrailType(tableType) {
      this.tableType = tableType
      this.$emit('changeTrackType')
    },
    // 退回
    async backTransfer() {
      const { data, code, msg } = await BackTransferApi.reqReback(
        {
          waybillNo: this.waybillNo,
          rebackTransferReason: '客户要求退回',  receiverMobilePhone: this.receiverMobilePhoneStatus ? '' : this.backFormData.receiverMobilePhone
        }
      )
      if (code === RESPONSE_CODE.SUCCESS_COPY) {
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
      this.backVisible = false
      console.log(this.orderInfo, data, code, msg, '>>>>')
    },
    // 改地址
    changeAddress() {
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          try {
            const { code, msg } = await BackTransferApi.reqTransfer(
              {
                ...this.formData,
                waybillNo: this.waybillNo,
                receiverProvinceName: this.selectProvide.nativeName, // 新收件省份名称 转寄必填
                receiverProvinceId: this.selectProvide.id, // 新收件省份id 转寄必填
                receiverCityName: this.selectCity.nativeName, // 新收件城市名称 转寄必填
                receiverCityId: this.selectCity.id, // 新收件城市id 转寄必填
                receiverAreaName: this.selectArea.nativeName, // 转寄】 新收件区域名称 转寄必填
                receiverAreaId: this.selectArea.id// 新收件区域id 转寄必填
              }
            )
            if (code === RESPONSE_CODE.SUCCESS_COPY) {
              this.$message.success(msg)
              this.visible = false
            } else {
              this.$message.error(msg)
            }
          } catch (err) {
            console.log(err)
          }
        }
      })
    },
    handleSubmit() {
      console.log(this.formData, '>>>>>111')
    },
    async getProvince() {
      const res = await BackTransferApi.reqSysArea({ type: 2, size: 1111111 })
      this.provideList = (res.data || {}).records
    },
    changeProvide(value) {
      this.getCity()
      console.log(value, '<<<<type')
      if (value.id && value.nativeName) {
        console.log('获取省份')
        this.formData.receiverProvinceId = this.selectProvide.id
      } else {
        this.formData.receiverCityId = this.opsInterceptObj.receiverCityId
        this.selectCity = {
          id: this.opsInterceptObj.receiverCityId,
          nativeName: this.opsInterceptObj.receiverCityName
        }
      }
    },
    async getCity() {
      this.selectCity = ''
      const res = await BackTransferApi.reqSysArea({ parentId: this.selectProvide.id, size: 2222222 })
      this.cityList = (res.data || {}).records
    },
    changeCity(value) {
      console.log(this.selectProvide, 'selectProvide')
      this.getArea()
      if (value.id && value.nativeName) {
        console.log('获取省份')
        this.formData.receiverCityId = this.selectCity.id
      } else {
        this.formData.receiverAreaId = this.opsInterceptObj.receiverAreaId
        this.selectArea = {
          id: this.opsInterceptObj.receiverAreaId,
          nativeName: this.opsInterceptObj.receiverAreaName
        }
      }
    },
    async getArea() {
      this.selectArea = ''
      const res = await BackTransferApi.reqSysArea({ parentId: this.selectCity.id, size: 3333333 })
      this.areaList = (res.data || {}).records
    },
    changeArea(value) {
      if (value.id && value.nativeName) {
        console.log('获取省份')
        this.formData.receiverAreaId = this.selectArea.id
      }
    },
    async handleOpsIntercept() {
      const { data, code, msg } = await BackTransferApi.reqAddress(this.opsIntercept)
      console.log(data, code, msg, '111')
      const { receiverProvinceId, receiverProvinceName, receiverDetailedAddress, receiverMobilePhone, receiverName } = data
      this.opsInterceptObj = data
      this.formData.receiverProvinceId = receiverProvinceId
      this.formData.receiverDetailedAddress = receiverDetailedAddress || this.formData.receiverDetailedAddress
      this.formData.receiverMobilePhone = receiverMobilePhone || this.formData.receiverMobilePhone
      this.formData.receiverName = receiverName || this.formData.receiverName
      this.selectProvide = {
        id: receiverProvinceId,
        nativeName: receiverProvinceName
      }
      this.changeProvide(1)
      this.changeCity(1)
    },
    async batchQueryRegister(type) {
      const { data, code, msg } = await BackTransferApi.reqBatchQueryRegister({
        waybillNos: [this.waybillNo],
        applyTypeCode: type
      })
      if (data && data.length) {
        if (data[0]?.enteringFlag === 1) {
          if (type === 3) {
            console.log(this.orderInfo, '>>>>orderInfo')
            this.backFormData.receiverMobilePhone = this.orderInfo.senderMobilePhone
            this.backVisible = true
          } else {
            this.getProvince()
            this.visible = true
          }
        } else {
          this.$message.error(data[0]?.remark)
        }
      }
      console.log(data, code, msg, '111')
    },
    handleClose() {
      console.log('<<<<<123')
      this.opsIntercept = ''
      this.selectProvide = ''
      this.selectCity = ''
      this.selectArea = ''
      this.$refs.formData.resetFields()
    },
    editReceiverMobilePhoneStatus() {
      this.receiverMobilePhoneStatus = !this.receiverMobilePhoneStatus
      this.$refs.backFormData.validateField('receiverMobilePhone');
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-collapse {
  min-width: 700px;
  .is-active {
    >:nth-child(1) {
      margin-bottom: 10px;
    }
  }
}
.switch-icon {
  display: inline-block;
  position: relative;
  margin-top: 7px;
  .my-icon {
    position: absolute;
    left: 0;
    color: #a1a3a6;
  }
  .my-icon-1 {
    bottom: 0px;
  }
  .my-icon-2 {
    top: -8px;
  }
  .active {
    color: #fb0000;
  }
}
.warning {
  display: flex;
  margin-left: 10px;
}
.el-icon-warning {
  color: #fb0000 !important;
  font-size: 23px;
  vertical-align: middle;
  margin-right:5px;
}
.color-red {
  color: #fb0000 !important;
}
.color-blue {
  color: blue !important;
}
.color-green {
  color: green !important;
}
.trail-btn {
  margin-bottom: 10px;
  margin-left: 10px;
  display: flex;
  line-height: 24px;
  &>span {
    width: 55px;
    border: 1px solid #C4C8CC;
    text-align: center;
    padding: 5px 10px;
    cursor: pointer;
  }
  &>span:nth-child(2) {
    border-left-color: #E60012;
    border-top-right-radius:20px ;
    border-bottom-right-radius:20px ;
  }
  &>span:first-child{
    border-right: none;
    border-top-left-radius:20px ;
    border-bottom-left-radius:20px ;
  }
  .trail-btn-active {
    border-color: #E60012;
    color: #E60012;
  }
}
.trail-tip {
  font-size: 13px;
  border: 1px solid #E60012;
  text-align: center;
  border-radius: 10px;
  background-color: #FBEDEB;
  color: #4C4D57 !important;
  margin-left: 20px;
  padding: 5px 15px;
  .iconjinggao1 {
    font-size: 20px;
    color: #E60012;
    font-weight: bolder;
  }
}
.form-second {
  display: inline-block;
  margin-top: 4.5px;
  @include text-color('subtitle');
  line-height: 1;
  font-size: 14px;
  font-weight: 600;
  height: 18px;
}
.form-tip {
  @include text-color('brand');
}
</style>
